import { API_URL } from '@/constants';

export const downloadFile = async (childId: number): Promise<void> => {
  const url = `${API_URL}/children/${childId}/excel`;

  const token = localStorage.getItem('token');
  if (!token) {
    console.error('Authorization token is missing.');
    return;
  }

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });

    if (!response.ok) {
      const errorDetails = await response.text();
      console.error('Error downloading file:', response.status, response.statusText, errorDetails);
      throw new Error(`Failed to download file: ${response.statusText}`);
    }

    // Base64文字列をデコードしてBlobに変換する処理
    const base64String = await response.text(); // サーバーからBase64形式の文字列を取得
    const binaryString = atob(base64String); // Base64デコード
    const byteNumbers = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      byteNumbers[i] = binaryString.charCodeAt(i);
    }
    const blob = new Blob([byteNumbers], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    // ファイルをダウンロード
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = downloadUrl;
    a.download = `契約内容報告書_${childId}.xlsx`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(downloadUrl);
    document.body.removeChild(a);
  } catch (error) {
    console.error('File download error:', error);
  }
};
